<template>
    <teleport :to="to" :disabled="disableTeleport">
        <div 
            ref="parentRef"
            :class="['mask', { 'blur': isShowBackdropFilterBlur}]" 
            @click.stop="clickMask" 
            @touchmove.prevent 
            :style="maskStyle"
        ></div>
    </teleport>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    opacity: {
        type: [Number, String],
        default: 0.5,
    },
    styleText: {
        type: String,
        default: '',
    },
    isShowBackdropFilterBlur: {
        type: Boolean,
        default: false,
    },
    zIndex: {
        type: Number,
        default: 1000000,
    },
    disableScroll: {
        type: Boolean,
        default: () => {
            return false;
        }
    },
    to: {
        type: String,
        default: 'body',
    },
    disableTeleport: {
        type: Boolean,
        default: false,
    },
});

const emits = defineEmits(['onClickMask']);

const maskStyle = computed(() => props.styleText ? props.styleText : `background: rgba(0,0,0,${ props.opacity }); z-index: ${ props.zIndex }`);

const clickMask = () => {
    emits('onClickMask');
};

const parentRef = ref();

// 禁用滚动事件
const disableScroll = () => {
    if (!parentRef.value) return;
    parentRef.value.addEventListener('wheel', preventScroll, { passive: false });
    parentRef.value.addEventListener('touchmove', preventScroll, { passive: false });
    parentRef.value.addEventListener('scroll', preventScroll, { passive: false });
    document.body.style.overflow = 'hidden';
};


const enableScroll = () => {
    document.body.style.overflow = 'auto';
    if (!parentRef.value) return;
    parentRef.value.removeEventListener('wheel', preventScroll);
    parentRef.value.removeEventListener('touchmove', preventScroll);
    parentRef.value.removeEventListener('scroll', preventScroll);
};

const preventScroll = (e) => {
    e.preventDefault();
};

onMounted(()=>{
    nextTick(() => {
        props.disableScroll && disableScroll();
    });
});

onUnmounted(() => {
    enableScroll();
});


</script>

<style lang="scss" scoped>
    .mask{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1000000;
    }
    @supports (-webkit-backdrop-filter:none) or (backdrop-filter:none) {
        .blur {   
            backdrop-filter: blur(35px);   
        }
    }
    @supports not ((-webkit-backdrop-filter:none) or (backdrop-filter:none)) {
        .blur {   
            background: linear-gradient(180deg,rgba(0,0,0, 0.7), rgba(0,0,0,1)) !important;
        }
    }
</style>
